import React from "react";

// Renders the packet's tiny markup: **bold** and line breaks. No HTML injection.
export default function Md({ text }) {
  const lines = String(text ?? "").split("\n");
  return lines.map((line, li) => (
    <React.Fragment key={li}>
      {li > 0 && <br />}
      {line.split(/(\*\*.+?\*\*)/g).map((part, i) =>
        part.startsWith("**") && part.endsWith("**") && part.length > 4 ? <strong key={i}>{part.slice(2, -2)}</strong> : <React.Fragment key={i}>{part}</React.Fragment>
      )}
    </React.Fragment>
  ));
}
